import { Popover } from 'antd';
import styled from 'styled-components';
import { ScoreBreakdownResult } from 'Types/SRITypes';
import { useSelector } from 'react-redux';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import { noPersonImage } from 'Utils/utilsStyle';
import { ReactNode } from 'react';
import SriScoreCard from './SriScoreCard';

type Props = {
  belt: string,
  image: string,
  children: ReactNode,
  name?: string,
  count?: number,
  scoreBreakdowResults: ScoreBreakdownResult[],
  certified: string,
} & typeof defaultProps;

const defaultProps = {
  name: 'Harsha Buksh',
  count: 1,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  .table-item{
    font-weight: bold;
    color: #424B50;
    font-size: 16px;
    font-family: Roboto;
    letter-spacing: -0.45px;
    height: 100%;
  }
  .id-col{
    width: 7%;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 6%;
    }
  }
  .belt-col{
    width: 7%;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 8%;
    }
    img{
      /* width: 43px;
      height: 24px; */
      width: 35px;
      height: 35px;
    }
  }
  .name-col{
    width: 22%;
    text-align: left;
    padding-left: 30px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 24%;
    }
    >div{
      display: flex;
      height: 35px;
      padding-right: 10px;
      align-items: center;
      padding-bottom: 0;
    }
    .name{
      padding-right: 15px;
      .ant-popover-inner-content{
        padding: 0;
      }
    }
    .certified-badge-div {
      position: relative;
      .certified-img {
        width: 25px;
        height: 25px;
      }

    }
    img{
      width: 35px;
      height: 35px;
      margin-right: 15px;
      border-radius: 50%;
    }
  }
  .ant-popover{
    z-index: 1;
  }
`;

const TeamChartBodyItem = function TeamChartBodyItem(props: Props) {
  const {
    certified, belt, image, children, name, count,
    scoreBreakdowResults,
  } = props;
  const disclessPersonality = useSelector(selectDisclessPersonality);
  return (
    <Wrapper className="table-body-row">
      <div className="table-item id-col">
        <div className="notranslate">
          <span className="rank">{count}</span>
        </div>
      </div>
      <div className="table-item belt-col">
        <div>
          <img src={belt} alt="progress-belt" />
        </div>
      </div>

      <div className="table-item name-col">
        <div>
          <img src={disclessPersonality ? noPersonImage : image} alt="avatar" />
          <Popover
            content={<SriScoreCard data={scoreBreakdowResults} />}
            trigger="hover"
            color=""
            key={name}
            getPopupContainer={(e: HTMLElement) => e}
            placement="right"
            className=""
            arrow={false}
          >
            <span className="name text-truncate">{name}</span>
          </Popover>
          <div className="certified-badge-div">
            {certified?.length ? <img src={certified} className="certified-img" alt="certified-badge" /> : null}
          </div>
        </div>
      </div>

      <div className="other-side">
        <div className="line-for-chart" />
        <div className="line-for-chart" />
        <div className="line-for-chart" />
        <div className="line-for-chart" />
        <div className="line-for-chart" />
        {children}
      </div>
    </Wrapper>
  );
};

TeamChartBodyItem.defaultProps = defaultProps;
export default TeamChartBodyItem;
